import dayjs from 'dayjs';
export { default } from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';

dayjs.extend(advancedFormat);
dayjs.extend(localizedFormat);
